import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: loadView("Home"),
      alias: "/home"
    },
    {
      path: "/about",
      name: "about",
      component: loadView("About")
    },
    {
      path: "/favorite",
      name: "favorite",
      component: loadView("Favorite")
    },
    {
      path: "/cart",
      name: "cart",
      component: loadView("Cart")
    },
    {
      path: "/login",
      name: "login",
      component: loadView("Login")
    },
    {
      path: "/register",
      name: "register",
      component: loadView("Register")
    },
    {
      path: "/profile",
      component: loadView("profile/Profile"),
      children: [
        {
          path: "",
          name: "profile",
          component: loadView("profile/ProfileShow")
        },
        {
          path: "update",
          name: "profileupdate",
          component: loadView("profile/ProfileUpdate")
        },
        {
          path: "changepassword",
          name: "changepassword",
          component: loadView("profile/ProfilePassword")
        },
        {
          path: "order",
          name: "order",
          component: loadView("profile/Order")
        },
        {
          path: "order/:id",
          name: "orderdetail",
          component: loadView("profile/OrderDetail")
        },
        {
          path: "address",
          component: loadView("profile/Address"),
          children: [
            {
              path: ":id",
              name: "addressEdit",
              component: loadView("profile/Address")
            }
          ]
        }
      ]
    },
    {
      path: "/products",
      name: "product",
      component: loadView("Product"),
      props(route) {
        return {
          search: route.query.search
        };
      }
    },
    {
      path: "/products/item/:id",
      name: "item",
      component: loadView("Item")
    },
    {
      path: "/paymentmethod",
      name: "paymentmethod",
      component: loadView("Paymentmethod")
    },
    {
      path: "/policy",
      name: "policy",
      component: loadView("Policy")
    },
    {
      path: "/contact",
      name: "contact",
      component: loadView("Contact")
    },
    {
      path: "*",
      name: "index",
      component: loadView("Home")
    }
  ]
});
